import React, { useEffect } from "react"
import { StaticQuery, graphql } from "gatsby"
import NotificationBar from "./NotificationBar"
const GlobalNotifications = ({ notification_bar }) => {
    const [
        notificationBlocksList,
        setNotificationBlocksList,
    ] = React.useState<any>([])
    let notificationBlocks
    return (
        <StaticQuery
            query={graphql`
        query {
          allStoryblokEntry(
            filter: { field_component: { eq: "notification_bar" } }
          ) {
            edges {
              node {
                uuid
                content
              }
            }
          }
        }
      `}
            render={(data) => {
                if (data && data.allStoryblokEntry) {
                    notificationBlocks = data.allStoryblokEntry.edges.filter((e) =>
                        notification_bar.includes(e.node.uuid)
                    )
                    useEffect(() => {
                        setNotificationBlocksList(notificationBlocks)
                    }, [])
                }

                const returnNotifications = notificationBlocksList.map((e) => {
                    const notificationContent = JSON.parse(e.node.content)
                    const todaysDate = new Date().toISOString().split("T")[0]
                    if (
                        notificationContent.notification_start_date <= todaysDate &&
                        notificationContent.notification_end_date >= todaysDate
                    ) {
                        return (
                            <NotificationBar
                                notification_id={notificationContent.notification_id}
                                notification_start_date={notificationContent.notification_start_date}
                                notification_end_date={notificationContent.notification_end_date}
                                notification_variant={notificationContent.notification_variant}
                                notification_text={notificationContent.notification_text}
                                notification_cta={notificationContent.notification_cta}
                            />
                        )
                    }
                })
                return returnNotifications
            }}
        />
    )
}
export default GlobalNotifications
